import { FC } from 'react'
import { observer } from 'mobx-react'
import { IPublicUser } from '@/types'
import WebsiteSvg from '@/public/images/common/website.svg'
import { UserDetailHeaderGeneralInfoItem } from '@components/molecules/UserDetailHeaderGeneralInfoItem'
import styles from './index.module.scss'

type Props = {
  user: IPublicUser
}

export const UserDetailHeaderGeneralInfo: FC<Props> = observer(({ user }) => {
  return (
    <div className={styles.container}>
      <UserDetailHeaderGeneralInfoItem logo={<WebsiteSvg />} text={user.profile.websiteUrl} isLink />
    </div>
  )
})
